<template>
  <div>
    <div class="popup-wrapper" @click.self="closeSelf">
      <div class="popup-container xl">
        <div class="button close close-fixed">
          <span role="button" class="btn" @click="closeSelf">
            <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
          </span>
        </div>
        <div class="popup mb120">

          <form @submit.prevent>
            <div class="popup-fixed">
              <div class="popup-title popup-title-fixed">
                <a @click.prevent.stop="group1.search" class="popup-title-button ga-search-qa-detail" role="button">
                  <FontawesomeIcon :icon="['far','search']" size="2x" class="icn" />
                  <span>この検索条件で検索する</span>
                </a>
                <span @click="group1.clearSearchCondition" class="popup-title-sup" role="button">検索条件をリセット</span>
              </div>
            </div>
            <div class="popup-content">
              <p v-if="group1.isError" class="error-message mt16 ml40">入力内容に不備があるようです。下記メッセージ（赤文字）のご確認をお願いいたします。</p>
              <div class="tab popup-content-01">

                <div class="tab-head">
                  <ul class="tab-label">
                    <li
                      role="button" 
                      @click="group1.changeTab1(1)"
                      :class="{'is-active': group1.tab1 === 1}"
                    >
                      キーワード検索
                    </li>
                    <li
                      role="button" 
                      @click="group1.changeTab1(2)"
                      :class="{'is-active': group1.tab1 === 2}"
                    >
                      AND / OR検索
                    </li>
                  </ul>
                  <div v-if="group1.tab1 === 1" class="formparts checkbox">
                    <input 
                      type="checkbox" :id="'qa_search_detail_is_fuzzy_' + group1.parentName"
                      v-model.number="group1.is_fuzzy_input" 
                      :true-value="0"
                      :false-value="1"
                    >
                    <label :for="'qa_search_detail_is_fuzzy_' + group1.parentName" role="button">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                  <div v-else-if="group1.tab1 === 2" class="formparts checkbox">
                    <input 
                      type="checkbox" :id="'qa_search_detail_andor_is_fuzzy_' + group1.parentName"
                      v-model.number="group1.andor_is_fuzzy_input" 
                      :true-value="0"
                      :false-value="1"
                    >
                    <label :for="'qa_search_detail_andor_is_fuzzy_' + group1.parentName" role="button">表記ゆれ・同意語を含む<FontawesomeIcon icon="check" class="icn" /></label>
                  </div>
                </div>

                <div class="tab-container">

                  <div id="tab_cnt_01_01" class="tab-content" :class="{'is-active': group1.tab1 === 1}">
                    <div class="hdg_checkbox">
                      <p class="hdg04 mb12">検索キーワード（AND検索）</p>

                    </div>
                    <div class="formparts text mb20">
                      <input v-model="group1.keyword_search_text_input" type="text" maxlength="50" placeholder="キーワード（最大50文字）">
                    </div>
                    <div class="hdg_checkbox">
                      <p class="hdg04 mb8">除外キーワード（OR検索）</p>
                      <p class="mb12">除外キーワードは、表記ゆれ・同意語を含むのチェックには含まれません。</p>
                    </div>
                    <div class="formparts text">
                      <input v-model="group1.keyword_excluding_text" type="text" maxlength="50" placeholder="除外キーワード（最大50文字）">
                    </div>
                  </div>

                  <div id="tab_cnt_01_02" class="tab-content" :class="{'is-active': group1.tab1 === 2}">
                    <div class="hdg_checkbox">
                      <p class="hdg04 mb12">検索キーワード</p>
                    </div>
                    <div class="box-gray mb32">
                      <table class="qa-content">
                        
                        <tr v-for="(item, index) in group1.andor_search_texts" :key="'andor_search_texts_' + index">
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text1" type="text" maxlength="50" placeholder="キーワード">
                            </div>
                          </td>
                          <td>
                            <span class="txt-sup">OR</span>
                          </td>
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text2" type="text" maxlength="50" placeholder="キーワード">
                            </div>
                          </td>
                          <td>
                            <span class="txt-sup">OR</span>
                          </td>
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text3" type="text" maxlength="50" placeholder="キーワード">
                            </div>
                          </td>
                          <td>
                            <span class="txt-sup">OR</span>
                          </td>
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text4" type="text" maxlength="50" placeholder="キーワード">
                            </div>
                          </td>
                          <td class="ta-center">
                            <span v-if="index < group1.andor_search_texts.length - 1" class="txt-sup">AND</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="ta-center">
                            <span class="add" role="button"
                              @click="group1.addSearchTextsRow"
                            >条件をプラスする<FontawesomeIcon :icon="['fal','plus']" class="icn" /></span>
                          </td>
                        </tr>

                      </table>
                    </div>
                    <div class="hdg_checkbox">
                      <p class="hdg04 mb8">除外キーワード</p>
                      <p class="mb12">除外キーワードは、表記ゆれ・同意語を含むのチェックには含まれません。</p>
                    </div>
                    <div class="box-gray">
                      <table class="qa-content">

                        <tr v-for="(item, index) in group1.andor_excluding_texts" :key="'andor_excluding_texts_' + index">
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text1" type="text" maxlength="50" placeholder="除外キーワード">
                            </div>
                          </td>
                          <td>
                            <span class="txt-sup">OR</span>
                          </td>
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text2" type="text" maxlength="50" placeholder="除外キーワード">
                            </div>
                          </td>
                          <td>
                            <span class="txt-sup">OR</span>
                          </td>
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text3" type="text" maxlength="50" placeholder="除外キーワード">
                            </div>
                          </td>
                          <td>
                            <span class="txt-sup">OR</span>
                          </td>
                          <td>
                            <div class="formparts text">
                              <input v-model="item.text4" type="text" maxlength="50" placeholder="除外キーワード">
                            </div>
                          </td>
                          <td class="ta-center">
                            <span v-if="index < group1.andor_excluding_texts.length - 1" class="txt-sup">AND</span>
                          </td>
                        </tr>
                        <tr>
                          <td class="ta-center">
                            <span class="add" role="button"
                              @click="group1.addExcludingTextsRow"
                            >条件をプラスする<FontawesomeIcon :icon="['fal','plus']" class="icn" /></span>
                          </td>
                        </tr>

                      </table>
                    </div>
                  </div>

                </div>

              </div>
              <div class="tab popup-content-02">
                <div class="tab-head">
                  <ul class="tab-label" role="tablist">
                    <li 
                      @click="group1.changeTab2(1)"
                      :class="{'is-active': group1.tab2 === 1}"
                      role="button" tabindex="1">パッケージを指定
                    </li>
                    <li 
                      @click="group1.changeTab2(2)"
                      :class="{'is-active': group1.tab2 === 2}"
                      role="button" tabindex="2">書籍を指定
                    </li>
                    <li 
                      @click="group1.changeTab2(3)"
                      :class="{'is-active': group1.tab2 === 3}"
                      role="button" tabindex="3">過去の世代を指定
                    </li>
                  </ul>
                </div>
                <div class="tab-container">

                  <!-- パッケージを指定 -->
                  <div class="tab-content tab-content-01" :class="{'is-active': group1.tab2 === 1}">
                    <FontawesomeIcon v-if="!group1.isPackagesAndProductsLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                    <template v-else>
                      <p v-if="group1.choices_packages.length == 0">ライセンス契約がありません。</p>
                      <template v-else>
                        <p class="txt mb10">検索対象となるパッケージを選択してください。※年度指定との併用はできません。</p>
                        <div v-for="item in group1.choices_packages" :key="'choices_packages_' + item.id" class="formparts checkbox inline">
                          <input v-model="group1.package_ids" :value="item.package_id" 
                          type="checkbox" :id="'package_' + item.id">
                          <label :for="'package_' + item.id">{{ item.name }}<FontawesomeIcon icon="check" class="icn" /></label>
                        </div>
                      </template>
                    </template>
                  </div>

                  <!-- 書籍を指定 -->
                  <div class="tab-content tab-content-02" :class="{'is-active': group1.tab2 === 2}">
                    <div class="tab-content-02-text">
                      <span class="txt mb0">検索対象となる書籍を選択してください。</span>
                      <span v-if="group1.selectedBookList.length > 0" @click="group1.clearBookChoices" class="txt-blue ml20" role="button">指定をクリア</span>
                    </div>
                    <div class="column">
                      <div class="column-item col-9">
                        <div class="formparts textarea is-inactive tab-content-02-textarea">
                        <textarea v-model="group1.selectedBookNamesDisp" rows="5" readonly></textarea>
                      </div>
                      </div>
                      <div class="column-item col-3 space-left">
                        <div class="button">
                          <span class="btn" role="button"
                            @click="openSearchBooks"
                          >
                            選択
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 過去の世代を指定 -->
                  <div class="tab-content tab-content-03" :class="{'is-active': group1.tab2 === 3}">

                    <FontawesomeIcon v-if="!group1.isRevisionsForChoiceLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
                    <template v-else>
                      <p v-if="group1.choices_revisions_packages.length == 0">過去世代はありません。</p>
                      <template v-else>
                        <div class="tab-content-03-text">
                          <span class="txt mb0">検索したい世代を選択してください。</span>
                          <span @click="group1.clearRevisionChoices" class="txt-blue ml20" role="button">指定をクリア</span>
                        </div>
                        <table class="tab-content-03-table">
                          <colgroup>
                            <col style="width:30%;">
                            <col style="width:70%;">
                          </colgroup>
                          <tbody>

                            <tr v-for="(item, index) in group1.choices_revisions_packages" :key="'choices_revisions_packages_' + index">
                              <th>{{ item.name }}</th>
                              <td>
                                <div class="column gutter">

                                  <div v-for="item2 in item.revisions" :key="'choices_revisions_' + item2.id" class="column-item col-4 space-gutter">
                                    <div class="formparts radio">
                                      <input v-model="group1.package_id_revision_id" 
                                      :value="item.id + ',' + item2.id"
                                      type="radio" :id="'revisions_' + item2.id">
                                      <label :for="'revisions_' + item2.id">{{ item2.name }}</label>
                                    </div>
                                  </div>

                                </div>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </template>
                    </template>

                  </div>
                  
                </div>
              </div>
              <div class="popup-content-03">
                <p class="hdg04 mb12 inline">
                  <span class="main">関連法令を指定</span>
                  <span class="sub" type="button"
                    @click="group1.isSingleSearch = !group1.isSingleSearch"
                    >
                    <template v-if="group1.isSingleSearch">複数法令を指定</template>
                    <template v-else>単一指定に戻す</template>
                  </span>
                </p>
                <p class="txt">条数は半角数字で入力してください。</p>
                <template v-if="group1.isSingleSearch">
                  <div class="column">
                    <div class="column-item left" style="width:calc(100% - 393px);">
                      <div class="formparts text">
                        <input v-model="group1.laws_single.title" type="text" placeholder="法令名">
                      </div>
                    </div>
                    <div class="column-item right" style="width:385px;">
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_single.article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_single.article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_single.article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_single.article4" type="text" maxlength="4">
                      </div>
                    </div>
                  </div>
                  <p v-if="group1.error_laws_single" class="error-message">{{ group1.error_laws_single }}</p>
                </template>
                <template v-else>
                  <div class="column">
                    <div class="column-item left" style="width:calc(100% - 600px);">
                      <div class="formparts text">
                        <input v-model="group1.laws_multi.group1.title" type="text" placeholder="法令名">
                      </div>
                    </div>
                    <div class="column-item right" style="width:592px;">
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group1.article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group1.article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group1.article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group1.article4" type="text" maxlength="4">
                      </div>
                      <span class="txt">を参照し、</span>
                      <div class="formparts select inline" style="width:110px;"
                        @mouseenter="state.isSelectboxVisibleOption = true"
                        @mouseleave="state.isSelectboxVisibleOption = false"
                        :class="{'is-visible-list': state.isSelectboxVisibleOption}"
                        >
                        <div class="select-label" role="select">
                          <template v-if="group1.laws_multi.group1_ope === 'and'">かつ</template>
                          <template v-else-if="group1.laws_multi.group1_ope === 'or'">または</template>
                          <FontawesomeIcon :icon="state.isSelectboxVisibleOption ? 'angle-up' : 'angle-down'" class="icn" />
                        </div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group1_ope" value="and" @click="state.isSelectboxVisibleOption = false">かつ</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group1_ope" value="or" @click="state.isSelectboxVisibleOption = false">または</label></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="group1.error_laws_multi_group1" class="error-message">{{ group1.error_laws_multi_group1 }}</p>
                  <div class="column">
                    <div class="column-item left" style="width:calc(100% - 600px);">
                      <div class="formparts text">
                        <input v-model="group1.laws_multi.group2.title" type="text" placeholder="法令名">
                      </div>
                    </div>
                    <div class="column-item right" style="width:592px;">
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group2.article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group2.article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group2.article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group2.article4" type="text" maxlength="4">
                      </div>
                      <span class="txt">を参照し、</span>
                      <div class="formparts select inline" style="width:110px;"
                        @mouseenter="state.isSelectbox2VisibleOption = true"
                        @mouseleave="state.isSelectbox2VisibleOption = false"
                        :class="{'is-visible-list': state.isSelectbox2VisibleOption}"
                      >
                        <div class="select-label" role="select">
                          <template v-if="group1.laws_multi.group2_ope == 'and'">かつ</template>
                          <template v-else-if="group1.laws_multi.group2_ope == 'or'">または</template>
                          <FontawesomeIcon :icon="state.isSelectbox2VisibleOption ? 'angle-up' : 'angle-down'" class="icn" />
                        </div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group2_ope" value="and" @click="state.isSelectbox2VisibleOption = false">かつ</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.laws_multi.group2_ope" value="or" @click="state.isSelectbox2VisibleOption = false">または</label></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p v-if="group1.error_laws_multi_group2" class="error-message">{{ group1.error_laws_multi_group2 }}</p>
                  <div class="column">
                    <div class="column-item left" style="width:calc(100% - 600px);">
                      <div class="formparts text">
                        <input v-model="group1.laws_multi.group3.title" type="text" placeholder="法令名">
                      </div>
                    </div>
                    <div class="column-item right" style="width:592px;">
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.from_article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.from_article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.from_article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.from_article4" type="text" maxlength="4">
                      </div>
                      <span class="txt">から</span>
                    </div>
                  </div>
                  <p v-if="group1.error_laws_multi_group3_from" class="error-message">{{ group1.error_laws_multi_group3_from }}</p>
                  <div class="column">
                    <div class="column-item left" style="width:calc(100% - 600px);">
                    </div>
                    <div class="column-item right" style="width:592px;">
                      <span class="txt">第</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.to_article1" type="text" maxlength="4">
                      </div>
                      <span class="txt">条の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.to_article2" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.to_article3" type="text" maxlength="4">
                      </div>
                      <span class="txt">の</span>
                      <div class="formparts text inline" style="width:62px;">
                        <input v-model.number="group1.laws_multi.group3.to_article4" type="text" maxlength="4">
                      </div>
                      <span class="txt">を参照する</span>
                    </div>
                  </div>
                  <p v-if="group1.error_laws_multi_group3_to" class="error-message">{{ group1.error_laws_multi_group3_to }}</p>
                </template>
              </div>

              <div class="popup-content-04">
                <p class="hdg04 mb12">裁判情報を指定</p>
                <p class="txt">検索対象となる裁判所を選択してください。<span @click="group1.clearJudgementChoices" class="txt-blue ml20" role="button">指定をクリア</span></p>
                <div class="column">
                  <div class="column-item col-9">
                    <div class="formparts text is-inactive">
                      <input v-model="group1.judgementCourtNamesDisp" type="text" readonly>
                    </div>
                  </div>
                  <div class="column-item col-3 space-left">
                    <div class="button">
                      <span class="btn" role="button"
                        @click="openSearchCourt"
                      >
                        裁判所検索
                      </span>
                    </div>
                  </div>
                </div>

                <div class="qa-content mt20">
                  <div class="qa-content-item">
                    <span class="title">裁判年月日</span>
                  </div>
                  <div class="qa-content-item-group">
                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        @mouseenter="selectBox.isVisibleEraList = true"
                        @mouseleave="selectBox.isVisibleEraList = false"
                        :class="{'is-visible-list': selectBox.isVisibleEraList}"
                      >
                        <div class="select-label" role="select">{{ group1.disp_judgement_era }}<FontawesomeIcon :icon="selectBox.isVisibleEraList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="">選択</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="令和">令和</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="平成">平成</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="昭和">昭和</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="大正">大正</label></li>
                            <li role="option"><label><input type="radio" v-model="group1.judgement.era" @click="selectBox.isVisibleEraList = false" value="明治">明治</label></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        @mouseenter="selectBox.isVisibleYearList = true"
                        @mouseleave="selectBox.isVisibleYearList = false"
                        :class="{'is-visible-list': selectBox.isVisibleYearList}"
                      >
                        <div class="select-label" role="select">{{ group1.disp_judgement_year }}<FontawesomeIcon :icon="selectBox.isVisibleYearList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option">
                              <label><input type="radio" v-model.number="group1.judgement.year" @click="selectBox.isVisibleYearList = false" value="0">選択</label>
                            </li>
                            <li v-for="n of group1.disp_judgement_last_year_of_era" :key="'judgement_year_' + n" role="option">
                              <label><input type="radio" v-model.number="group1.judgement.year" @click="selectBox.isVisibleYearList = false" :value="n">{{ (n === 1) ? '元' : n }}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="qa-content-item">
                      <span class="text">年</span>
                    </div>
                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        @mouseenter="selectBox.isVisibleMonthList = true"
                        @mouseleave="selectBox.isVisibleMonthList = false"
                        :class="{'is-visible-list': selectBox.isVisibleMonthList}"
                      >
                        <div class="select-label" role="select">{{ group1.disp_judgement_month }}<FontawesomeIcon :icon="selectBox.isVisibleMonthList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option">
                              <label><input type="radio" v-model.number="group1.judgement.month" @click="selectBox.isVisibleMonthList = false" :value="0">選択</label>
                            </li>
                            <li v-for="n of 12" :key="'judgement_month_' + n" role="option">
                              <label><input type="radio" v-model.number="group1.judgement.month" @click="selectBox.isVisibleMonthList = false" :value="n">{{n}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="qa-content-item">
                      <span class="text">月</span>
                    </div>
                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        @mouseenter="selectBox.isVisibleMdayList = true"
                        @mouseleave="selectBox.isVisibleMdayList = false"
                        :class="{'is-visible-list': selectBox.isVisibleMdayList}"
                      >
                        <div class="select-label" role="select">{{ group1.disp_judgement_mday }}<FontawesomeIcon :icon="selectBox.isVisibleMdayList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option">
                              <label><input type="radio" v-model.number="group1.judgement.mday" @click="selectBox.isVisibleMdayList = false" :value="0">選択</label>
                            </li>
                            <li v-for="n of 31" :key="'judgement_mday_' + n" role="option">
                              <label><input type="radio" v-model.number="group1.judgement.mday" @click="selectBox.isVisibleMdayList = false" :value="n">{{n}}</label>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="qa-content-item">
                      <span v-if="group1.judgement.restriction === 2" class="text">日から</span>
                      <span v-else class="text">日</span>
                    </div>
                    <div class="qa-content-item">
                      <div class="formparts select inline"
                        style="min-width:120px;"
                        @mouseenter="selectBox.isVisibleRestrictionList = true"
                        @mouseleave="selectBox.isVisibleRestrictionList = false"
                        :class="{'is-visible-list': selectBox.isVisibleRestrictionList}"
                      >
                        <div class="select-label" role="select">{{ group1.disp_judgement_restriction }}<FontawesomeIcon :icon="selectBox.isVisibleRestrictionList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                        <div class="select-option">
                          <ul class="select-option-list">
                            <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="1">日指定</label></li>
                            <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="2">期間指定</label></li>
                            <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="3">指定日以降</label></li>
                            <li role="option"><label><input type="radio" v-model.number="group1.judgement.restriction" @click="selectBox.isVisibleRestrictionList = false" value="4">指定日以前</label></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <p v-if="group1.error_judgement_date" class="error-message">{{ group1.error_judgement_date }}</p>
                  </div>
                </div>

                <template v-if="group1.judgement.restriction === 2">
                  <div class="qa-content mt16">
                    <div class="qa-content-item">
                      <span class="title"></span>
                    </div>
                    <div class="qa-content-item-group">
                      <div class="qa-content-item">
                        <div class="formparts select inline"
                          @mouseenter="selectBox.isVisibleEndEraList = true"
                          @mouseleave="selectBox.isVisibleEndEraList = false"
                          :class="{'is-visible-list': selectBox.isVisibleEndEraList}"
                        >
                          <div class="select-label" role="select">{{ group1.disp_judgement_end_era }}<FontawesomeIcon :icon="selectBox.isVisibleEndEraList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                          <div class="select-option">
                            <ul class="select-option-list">
                              <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="">選択</label></li>
                              <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="令和">令和</label></li>
                              <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="平成">平成</label></li>
                              <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="昭和">昭和</label></li>
                              <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="大正">大正</label></li>
                              <li role="option"><label><input type="radio" v-model="group1.judgement.end_era" @click="selectBox.isVisibleEndEraList = false" value="明治">明治</label></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="qa-content-item">
                        <div class="formparts select inline"
                          @mouseenter="selectBox.isVisibleEndYearList = true"
                          @mouseleave="selectBox.isVisibleEndYearList = false"
                          :class="{'is-visible-list': selectBox.isVisibleEndYearList}"
                        >
                          <div class="select-label" role="select">{{ group1.disp_judgement_end_year }}<FontawesomeIcon :icon="selectBox.isVisibleEndYearList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                          <div class="select-option">
                            <ul class="select-option-list">
                              <li role="option">
                                <label><input type="radio" v-model.number="group1.judgement.end_year" @click="selectBox.isVisibleEndYearList = false" :value="0">選択</label>
                              </li>
                              <li v-for="n of group1.disp_judgement_end_last_year_of_era" :key="'judgement_end_year_' + n" role="option">
                                <label><input type="radio" v-model.number="group1.judgement.end_year" @click="selectBox.isVisibleEndYearList = false" :value="n">{{ (n === 1) ? '元' : n }}</label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="qa-content-item">
                        <span class="text">年</span>
                      </div>
                      <div class="qa-content-item">
                        <div class="formparts select inline"
                          @mouseenter="selectBox.isVisibleEndMonthList = true"
                          @mouseleave="selectBox.isVisibleEndMonthList = false"
                          :class="{'is-visible-list': selectBox.isVisibleEndMonthList}"
                        >
                          <div class="select-label" role="select">{{ group1.disp_judgement_end_month }}<FontawesomeIcon :icon="selectBox.isVisibleEndMonthList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                          <div class="select-option">
                            <ul class="select-option-list">
                              <li role="option">
                                <label><input type="radio" v-model.number="group1.judgement.end_month" @click="selectBox.isVisibleEndMonthList = false" :value="0">選択</label>
                              </li>
                              <li v-for="n of 12" :key="'judgement_end_month_' + n" role="option">
                                <label><input type="radio" v-model.number="group1.judgement.end_month" @click="selectBox.isVisibleEndMonthList = false" :value="n">{{n}}</label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="qa-content-item">
                        <span class="text">月</span>
                      </div>
                      <div class="qa-content-item">
                        <div class="formparts select inline"
                          @mouseenter="selectBox.isVisibleEndMdayList = true"
                          @mouseleave="selectBox.isVisibleEndMdayList = false"
                          :class="{'is-visible-list': selectBox.isVisibleEndMdayList}"
                        >
                          <div class="select-label" role="select">{{ group1.disp_judgement_end_mday }}<FontawesomeIcon :icon="selectBox.isVisibleEndMdayList ? 'angle-up' : 'angle-down'" class="icn" /></div>
                          <div class="select-option">
                            <ul class="select-option-list">
                              <li role="option">
                                <label><input type="radio" v-model.number="group1.judgement.end_mday" @click="selectBox.isVisibleEndMdayList = false" :value="0">選択</label>
                              </li>
                              <li v-for="n of 31" :key="'judgement_end_mday_' + n" role="option">
                                <label><input type="radio" v-model.number="group1.judgement.end_mday" @click="selectBox.isVisibleEndMdayList = false" :value="n">{{n}}</label>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="qa-content-item">
                        <span class="text">日まで</span>
                      </div>
                      <p v-if="group1.error_judgement_end_date" class="error-message">{{ group1.error_judgement_end_date }}</p>
                    </div>
                  </div>
                </template>

                <div class="qa-content mt16">
                  <div class="qa-content-item">
                    <span class="title">事件名</span>
                  </div>
                  <div class="qa-content-item flex-auto mr0">
                    <div class="formparts text">
                      <input v-model="group1.case_name" type="text" placeholder="事件名">
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <!-- 書籍検索 -->
    <transition name="popup">
      <PCQASearchDetailBookList
        v-if="state.visibleSearchDetailBookList"
        :startLoading="state.visibleSearchDetailBookList"
        @closeSearchDetailBookList="state.visibleSearchDetailBookList = false"
      />
    </transition>

    <!-- 裁判所検索 -->
    <transition name="popup">
      <PCQASearchDetailCourtList
        v-if="state.visibleSearchDetailCourtList"
        :startLoading="state.visibleSearchDetailCourtList"
        @updateCourtNames="group1.updateCourtNames"
        @closeSearchDetailCourtList="state.visibleSearchDetailCourtList = false"
      />
    </transition>

  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import PCQASearchDetailCourtList from '@/components/pc/popup/PCQASearchDetailCourtList.vue'
import PCQASearchDetailBookList from '@/components/pc/popup/PCQASearchDetailBookList.vue'
import PCQASearchDetailSignList from '@/components/pc/popup/PCQASearchDetailSignList.vue'
import * as logicQASearchDetail from '@/logic/qa/QASearchDetail'

export default defineComponent({
  components: {
    PCQASearchDetailCourtList,
    PCQASearchDetailBookList,
    PCQASearchDetailSignList
  },
  props: {
    startLoading: {
      type: Boolean,
      required: true
    },
    // 呼び出し元の名前
    parentName: {
      type: String,
      required: true
    },
    // メニューから呼ばれた場合のその呼び出し元の名前
    parentNameOfMenu: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {

    const group1 = logicQASearchDetail.getGroup(props, context)

    const state = reactive({
      isSelectboxVisibleOption: false,
      isSelectbox2VisibleOption: false,
      countSearchKeyword: 3,
      countRejectKeyword: 1,
      visibleSearchDetailCourtList: false,
      visibleSearchDetailBookList: false
    })
    const selectBox = reactive({
      isVisibleEraList: false,
      isVisibleYearList: false,
      isVisibleMonthList: false,
      isVisibleMdayList: false,
      isVisibleEndEraList: false,
      isVisibleEndYearList: false,
      isVisibleEndMonthList: false,
      isVisibleEndMdayList: false,
      isVisibleRestrictionList: false
    })
    const incrementRelatedLowCount = () => {
      state.countRelatedLowInput++
    }
    const closeSelf = () => {
      context.emit('closeSearchDetail')
    }
    const openSearchCourt = () => {
      // context.emit('openSearchCourt')
      state.visibleSearchDetailCourtList = true
    }
    const openSearchBooks = () => {
      state.visibleSearchDetailBookList = true
    }

    return {
      group1,
      selectBox,
      closeSelf,
      openSearchCourt,
      openSearchBooks,
      state,
      incrementRelatedLowCount
    }
  }
})
</script>

<style lang="scss" scoped>

.popup {
  &-title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    background-color: #fff;
    z-index: 5;
    &-button {
      color: #fff;
      background-color: #0070D3;
      width: 460px;
      height: 48px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity .2s ease;
      &:hover {
        opacity: .7;
      }
      .icn {
        width: 20px;
      }
    }
    &-sup {
      //position: absolute;
      //right: 124px;
      //top: 50%;
      //transform: translate3d(0,-50%,0);
      margin-left: 20px;
      color: #005BAC;
      font-size: 1.2rem;
      transition: opacity .2s ease;
      &:hover {
        opacity: .7;
      }
    }
  }
  &-content {
    padding: 0!important;
    &-01,
    &-02 {
      margin: 32px 40px;
      border: 1px solid $color-line;
    }
    .tab {
      &-head {
        padding: 0;
      }
      &-label {
        li {
          border-top: 0;
          border-left: 0;
        }
      }
      &-content {
        padding: 32px 40px;
      }
    }
    &-01 {
      table {
        border-collapse: collapse;
        td {
          padding: 0 8px 8px 0;
          height: 48px;
        }
        .add {
          color: $color-link;
        }
      }
    }
    &-02 {
      .tab-content-02 {
        &-text {
          margin-bottom: 12px;
        }
      }
      .tab-content-03 {
        &-table {
          width: 100%;
          text-align: left;
          border-collapse: collapse;
          th,td {
            font-size: 1.6rem;
            padding: 16px 0;
          }
          th {
            color: $color-sup;
            text-align: left;
            vertical-align: text-top;
            font-weight: normal;
          }
        }
      }
    }
    &-03 {
      border-top: 1px solid $color-line;
      padding: 32px 40px;
      .hdg04 {
        .main,
        .sub {
          vertical-align: middle;
        }
        .sub {
          color: $color-link;
          margin-left: 20px;
          font-size: 1.6rem;
          @include hoverOpacity;
        }
      }
      .txt {
        margin-right: 8px;
      }
      .formparts.inline {
        margin: 0 8px 0 0;
      }
      .column {
        & +.column {
          margin-top: 16px;
        }
      }
      .column-item.right {
        width: 592px;
        margin-left: 8px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .txt {
          margin: 0 8px 0 0;
        }
        .formparts:last-child {
          margin-right: 0;
        }
      }
    }
    &-04 {
      border-top: 1px solid $color-line;
      padding: 32px 40px;
      .formparts.function {
        .text {
          width: calc(100% - 100px);
        }
        .button {
          width: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .formparts.text {
        display: flex;
        align-items: baseline;
        background-color: #f0f0f0;
        border-radius: 4px; 
        .text-clear {
          display: inline-block;
          margin: 10px;
          color: $color-link;
          font-size: 1.6rem;
          white-space: nowrap;
          @include hoverOpacity();
        }
      }
      .qa-content {
        position: relative;
        display: flex;
        align-items: center;
        &-item-group{
          display: inline-block;
          .error-message{
            display: block;
            margin: 5px 0 0 4px;
          }
        }
        &-item {
          display: inline-block;
          margin: 0 4px;
          .title {
            width: 100px;
            display: block;
          }
          .title,
          .text {
            color: $color-content;
          }
          .formparts {
            margin: 0;
          }
          &.flex-auto {
            flex: auto;
          }
        }
        .select-option {
          display: block;
          visibility: hidden;
        }
        .is-visible-list {
          .select-option {
            display: block;
            visibility: visible;
          }
        }
      }
      .fugo {
        position: absolute;
        right: 0;
      }
    }
    // .tab-content-list {
    //   list-style: none;
    //   padding-bottom: 20px;
    //   &-item {
    //     padding: 20px 40px;
    //     & + li {
    //       border-top: 1px solid $color-line;
    //     }
    //     & > .formparts:last-child {
    //       margin-bottom: 0;
    //     }
    //   }
    // }
  }
}
.tab-content > .formparts + .formparts{
  margin-top: 0;
}

// .qa-search-detail01_02,
// .qa-search-detail02_02 {
//   .tab {
//     border: 1px solid $color-line;
//     &-head {
//       padding: 0;
//     }
//     &-label {
//       li {
//         border-top: none;
//         border-left: none;
//       }
//     }
//     &-content {
//       padding: 30px 40px;
//       &-02 {
//         &-textarea {
//           position: relative;
//           display: flex;
//           align-items: baseline;
//           background-color: #f0f0f0;
//           border-radius: 4px;
//           textarea {
//             padding-right: 120px;
//           }
//           .text-clear {
//             position: absolute;
//             right: 10px;
//             display: inline-block;
//             margin: 10px;
//             color: $color-link;
//             font-size: 1.6rem;
//             white-space: nowrap;
//             @include hoverOpacity();
//           }
//         }
//       }
//       &-03 {
//         &-text {
//           .txt {
//             display: inline-block;
//           }
//           .txt-blue {
//             display: inline-block;
//           }
//         }
//         &-table {
//           width: 100%;
//           text-align: left;
//           border-collapse: collapse;
//           th,td {
//             font-size: 1.6rem;
//             padding: 16px 0;
//           }
//           th {
//             color: $color-sup;
//             vertical-align: text-top;
//             font-weight: normal;
//           }
//         }
//       }
//     }
//   }
// }

// .qa-search-detail01_03,
// .qa-search-detail02_03 {
//   .column + .column {
//     margin-top: 16px;
//   }
// }

// .qa-search-detail01_04,
// .qa-search-detail02_04 {
//   .hdg04 {
//     .sub {
//       color: $color-link;
//       font-size: 1.6rem;
//       margin-left: 20px;
//       font-weight: normal;
//       @include hoverOpacity;
//     }
//   }
//   .txt {
//     margin-right: 8px;
//   }
//   .formparts.inline {
//     margin: 0 8px 0 0;
//   }
//   .column {
//     & +.column {
//       margin-top: 16px;
//     }
//   }
//   .column-item.left {
//     // width: calc(100% - 600px);
//   }
//   .column-item.right {
//     width: 592px;
//     margin-left: 8px;
//     display: flex;
//     align-items: center;
//     justify-content: flex-start;
//     .txt {
//       margin: 0 8px 0 0;
//     }
//     .formparts:last-child {
//       margin-right: 0;
//     }
//   }
// }
// .qa-search-detail01_05,
// .qa-search-detail02_05 {
//   .formparts.function {
//     .text {
//       width: calc(100% - 100px);
//     }
//     .button {
//       width: 100px;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//     }
//   }
//   .formparts.text {
//     display: flex;
//     align-items: baseline;
//     background-color: #f0f0f0;
//     border-radius: 4px; 
//     .text-clear {
//       display: inline-block;
//       margin: 10px;
//       color: $color-link;
//       font-size: 1.6rem;
//       white-space: nowrap;
//       @include hoverOpacity();
//     }
//   }
//   .qa-content {
//     position: relative;
//     display: flex;
//     align-items: center;
//     &-item {
//       display: inline-block;
//       margin: 0 4px;
//       .title {
//         width: 100px;
//         display: block;
//       }
//       .formparts {
//         margin: 0;
//       }
//       &.flex-auto {
//         flex: auto;
//       }
//     }
//   }
//   .fugo {
//     position: absolute;
//     right: 0;
//   }
// }
// .qa-search-detail02_01 {
//   .box-gray {
//     background-color: #F9F8F6;
//     padding: 32px 40px;
//   }
//   .qa-content {
//     td {
//       height: 48px;
//       padding: 4px;
//     }
//     .formparts {
//       margin-bottom: 0;
//     }
//     .add {
//       color: $color-link;
//       svg {
//         margin-left: 4px;
//       }
//     }
//   }
// }
</style>
